module.exports = __webpack_public_path__ + "sounds/resources/sounds/echoed-ding-459.b781c2ce1bf3d49a4b7fbb29e435abfe.m4r";